// src/interface/map.ts
var MapType = /* @__PURE__ */ ((MapType2) => {
  MapType2["GAODE1.x"] = "GAODE1.x";
  MapType2["GAODE2.x"] = "GAODE2.x";
  MapType2["MAPBOX"] = "MAPBOX";
  MapType2["DEFAULT"] = "DEFAUlTMAP";
  MapType2["SIMPLE"] = "SIMPLE";
  MapType2["GLOBEL"] = "GLOBEL";
  return MapType2;
})(MapType || {});
export {
  MapType
};
